// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_nx-0";